<template>
  <FormRow with-three-columns>
    <FormInput
    :ref="`accountCodeEl-${plan.id}`" 
    :name="`accountCode-${plan.id}`"
    type="text" 
    :label="accountCodeInputLabel"
    v-model="accountCode.value" />

    <FormInput
    :ref="`itemCodeEl-${plan.id}`" 
    :name="`itemCode-${plan.id}`"
    type="text" 
    :label="t(`memberships.form.itemCode`)"
    v-model="itemCode.value" />

    <FormInput
    :ref="`priceEl-${plan.id}`" 
    :name="`price-${plan.id}`"
    type="text" 
    :label="priceInputLabel"
    :rules="[min(0), required]"
    v-model.number="price" />
  </FormRow>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from "vue";
import FormRow from "@/components/forms/FormRow.vue";
import FormInput from "@/components/forms/FormInput.vue";

import { useI18n } from "vue3-i18n";
import { min, required } from "@/validation/rules";
import {Plan, PlanType} from "@/types/entities/plan";

const { t } = useI18n()

// eslint-disable-next-line
const props = defineProps<{
  value: Plan;
}>();

// eslint-disable-next-line
const emit = defineEmits<{
  (event: "planUpdated", value: Plan): void;
}>();

const plan = ref(props.value)
const accountCode = ref(props.value.product?.accountingSoftwareProduct?.accountCode ?? {})
const itemCode = ref(props.value.product?.accountingSoftwareProduct?.itemCode ?? {})
const price = ref(props.value.product?.price)


const priceInputLabel = computed(() => {
  if (plan.value.type == PlanType.Syndicate)
    return t(`memberships.form.unitPrice${plan.value.unitsMin != undefined && plan.value.unitsMin > 1 ? plan.value.unitsMin : ''
      }${plan.value.unitsMax != undefined && plan.value.unitsMax > 1 ? `And${plan.value.unitsMax}` : ''}units`);
  else return t(`memberships.form.unitPrice`)
})

const accountCodeInputLabel = computed(() => {
  let label = t(`memberships.form.accountCode`)
  if (plan.value.unitsMin == null)
    label += " " + plan.value.chapter
  return label
})


watch(props, (newVal) => {
  plan.value = newVal.value
  accountCode.value = newVal.value.product?.accountingSoftwareProduct?.accountCode ?? {}
  itemCode.value = newVal.value.product?.accountingSoftwareProduct?.itemCode ?? {}
  price.value = newVal.value.product?.price
}, { immediate: true, deep: true })

watch(accountCode, (newVal) => {
  if(plan.value.product?.accountingSoftwareProduct != null)
    plan.value.product.accountingSoftwareProduct.accountCode = newVal
  emit('planUpdated', plan.value)
}, { immediate: true, deep: true })

watch(itemCode, (newVal) => {
  if(plan.value.product?.accountingSoftwareProduct != null)
  plan.value.product.accountingSoftwareProduct.itemCode = newVal
  emit('planUpdated', plan.value)
}, { immediate: true, deep: true })

watch(price, (newVal) => {
  if(plan.value.product != null){
    plan.value.product.price = newVal;
    emit('planUpdated', plan.value)
  }
})
</script>
